import React, { useState, useRef } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { Share } from '@capacitor/share';
import { Filesystem, Directory } from '@capacitor/filesystem';
import html2canvas from 'html2canvas';

interface ComprobanteTicketProps {
  svgBase64: string;
  facturaId: string | number;
  onClose: () => void;
}

const ComprobanteTicket: React.FC<ComprobanteTicketProps> = ({ svgBase64, facturaId, onClose }) => {
  const [sharing, setSharing] = useState(false);
  const ticketRef = useRef<HTMLDivElement>(null);

  const dataUrl = `data:image/svg+xml;base64,${svgBase64}`;

  const handleCompartir = async () => {
    setSharing(true);
    try {
      if (!ticketRef.current) return;

      const canvas = await html2canvas(ticketRef.current, {
        scale: 2,
        useCORS: true,
        // Papel del comprobante exportado: blanco fijo a proposito. No es color
        // de interfaz, es el fondo del PNG que se comparte por WhatsApp/correo,
        // y ademas html2canvas no resuelve var() en esta opcion.
        backgroundColor: '#ffffff',
      });

      const pngBase64 = canvas.toDataURL('image/png').split(',')[1];

      // Guardar en sisnetel/ dentro de Cache — registrado en file_paths.xml
      await Filesystem.writeFile({
        path: 'sisnetel/comprobante_sisnetel.png',
        data: pngBase64,
        directory: Directory.Cache,
        recursive: true,
      });

      const fileUri = await Filesystem.getUri({
        path: 'sisnetel/comprobante_sisnetel.png',
        directory: Directory.Cache,
      });

      await Share.share({
        title: `Comprobante Sisnetel #${facturaId}`,
        text: 'Comprobante de pago Sisnetel Fiber EC',
        url: fileUri.uri,
        dialogTitle: 'Compartir comprobante',
      });
    } catch (e) {
      console.error('Error al compartir:', e);
    } finally {
      setSharing(false);
    }
  };

  return (
    <div>
      {/* Este div es lo que html2canvas rasteriza: su fondo es el papel del
          comprobante, blanco fijo en ambos temas para que el PNG compartido
          no salga con un marco oscuro alrededor del ticket. */}
      <div ref={ticketRef} style={{ borderRadius: 12, overflow: 'hidden', background: '#ffffff', padding: 8 }}>
        <img
          src={dataUrl}
          alt="Comprobante de pago"
          style={{ width: '100%', display: 'block', borderRadius: 10 }}
        />
      </div>
      <div className="d-flex gap-2 mt-3 px-1">
        <Button
          variant="primary"
          className="w-100"
          onClick={handleCompartir}
          disabled={sharing}
          style={{ background: 'var(--sn-accion)', borderColor: 'var(--sn-accion)', color: 'var(--sn-accion-texto)' }}
        >
          {sharing
            ? <><Spinner animation="border" size="sm" className="me-2" />Generando...</>
            : '📤 Compartir comprobante'}
        </Button>
        <Button
          variant="outline-secondary"
          className="w-100"
          onClick={onClose}
          style={{ background: 'transparent', borderColor: 'var(--sn-borde-fuerte)', color: 'var(--sn-texto-2)' }}
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
};

export default ComprobanteTicket;
